'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Maybe = require('../../Maybe');

var _Maybe2 = _interopRequireDefault(_Maybe);

var _Restaurant = require('../Restaurant');

var _Restaurant2 = _interopRequireDefault(_Restaurant);

var _wixrestProperties = require('@wix/wixrest-properties');

var _wixrestProperties2 = _interopRequireDefault(_wixrestProperties);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _DefaultFutureDeliveryTime = require('./DefaultFutureDeliveryTime');

var _DefaultFutureDeliveryTime2 = _interopRequireDefault(_DefaultFutureDeliveryTime);

var _Properties = require('../../Properties');

var _Properties2 = _interopRequireDefault(_Properties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var futureDeliveryMethods = ["submitAt", "deliveryTime"];

function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    console.log.apply(console, ["[FutureDeliveryHelper] "].concat(args));
}

exports.default = {
    getFutureDeliveryMethods: function getFutureDeliveryMethods() {
        return futureDeliveryMethods;
    },
    getDeliveryTime: function getDeliveryTime(cart) {
        return cart.delivery && cart.delivery.time || cart.submitAt;
    },
    getFutureOrderTime: function getFutureOrderTime(cart) {
        return cart.delivery && cart.delivery.time;
    },
    getDefaultSettings: function getDefaultSettings() {
        return {
            minDelay: 1 * 24 * 60,
            maxDelay: 7 * 24 * 60,
            whenPop: 0
        };
    },
    getFutureOrdersWhenPopMinutes: function getFutureOrdersWhenPopMinutes(org) {
        return _Properties2.default.get(org, _wixrestProperties2.default.RestaurantProperties.WixRestaurant.FUTURE_ORDERS["SCHEDULE_AS_NEW_MINUTES"], 'com.openrest');
    },
    shouldDisplayOrderAsNew: function shouldDisplayOrderAsNew(order, whenPopTimeMins) {
        if (!this.isFutureOrder(order) || !whenPopTimeMins) return true;

        var now = (0, _moment2.default)();
        var deliveryTime = (0, _moment2.default)(order.delivery.time);
        var diffMs = deliveryTime - now;
        var diffMin = _moment2.default.duration(diffMs).asMinutes();
        return diffMin <= whenPopTimeMins;
    },
    isFutureOrder: function isFutureOrder(order) {
        return order.delivery && order.delivery.timeGuarantee === "about";
    },
    isFutureOrderCart: function isFutureOrderCart(cart) {
        return !!cart.delivery.time;
    },
    isAsapCart: function isAsapCart(cart) {
        return !this.isFutureOrderCart(cart);
    },
    isPreorderCart: function isPreorderCart(cart) {
        return cart.submitAt > 0;
    },
    isFeatureToggled: function isFeatureToggled() {
        // let windowExists = typeof window !== "undefined";
        // let isProd = windowExists && window.spiceProduction;
        // return !isProd;
        return true;
    },
    isFutureOrdersActivated: function isFutureOrdersActivated(organization) {
        return !_lodash2.default.get(organization, 'orders.future.disabled');
    }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/FutureDelivery/FutureDeliveryHelper.js
// module id = 181
// module chunks = 0